// extracted by mini-css-extract-plugin
export var dropdown = "_ue-0";
export var imageWrapper = "_ue-3";
export var itemNameContainer = "_ue-1";
export var productImage = "_ue-2";
export var spinnerWrapper = "_ue-4";